import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=5068a244"
import script from "./SelectResource.vue?vue&type=script&lang=ts"
export * from "./SelectResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports